import React from 'react';
import EylulGerceklesen from './EylulGerceklesen';

/**
 * KIXX Sports Club — Eylül 2026 medya planı (tam plan, kampanya kırılımlı).
 *
 * `/budget/kixx-eylul-2026` üç slaytlık bütçe TALEBİ (₺150.000). Bu sayfa
 * paranın kampanya kampanya nereye gittiğini gösteren PLAN. İkisi ayrı belge.
 *
 * 🔑 1 Eylül revizyonu (Efe): toplam ₺150.000 → ₺130.000 ve ağırlık Meta'dan
 * Google'a kaydırıldı. İki adımda: önce Meta'dan ₺20.000 kesilip toplam
 * düşürüldü, sonra Meta'dan ₺20.000 daha kesilip Google'a verildi.
 * Sonuç: Meta ₺90.000 → ₺50.000, Google ₺54.000 → ₺74.000, TikTok ₺6.000 sabit.
 * 🔴 Slayt sürümü hâlâ ₺150.000 diyor, güncellenmedi.
 *
 * 🔴🔴 Bu dağılımda bütçenin %57'si Google'da, ama Google'ın dönüşüm ölçümü
 * çalışmıyor (Ağustos: 563 tık, 3 dönüşüm). Lead projeksiyonu bu yüzden
 * SADECE Meta üzerinden verilir; Google satırlarına lead yazılmaz.
 *
 * Ağustos rakamları 1 Eylül 2026'da, ay KAPANDIKTAN sonra çekildi
 * (slayt sürümündeki ₺59.219, 31 Ağu 14:29 itibarıyla kısmi veriydi;
 * kapanan ay ₺59.567). Kaynaklar:
 *  · Meta   → Graph API act_4522438977986893, kampanya seviyesi insights.
 *  · Google → fetch_google_ads_campaign_insights_live.py + group_monthly,
 *             müşteri 9593387784 (Kixx Google Ads).
 *
 * Kampanya adları hesapta CANLI olarak duran adlardır, uydurulmadı.
 * TikTok satırı varsayımdır: markanın TikTok reklam hesabı yok.
 */

/* Gerçekleşen bölümünün plana bakacağı mecra bütçeleri; aşağıdaki plan
   tablosuyla AYNI rakamlar (Google 74.000 + Meta 50.000 + TikTok 6.000).
   Tabloyu değiştirirsen burayı da değiştir. */
export const BRAND_ID = 'd350d46e-fa7e-4aa0-98d6-317aca15c607';
export const MECRA_PLANI = { GOOGLE_ADS: 74000, META_ADS: 50000, TIKTOK_ADS: 6000 };

const AMAC_STIL = {
  'Farkındalık': 'bg-red-50 text-red-700 border-red-200',
  'Etkileşim': 'bg-pink-50 text-pink-700 border-pink-200',
  'Trafik': 'bg-sky-50 text-sky-700 border-sky-200',
  'Dönüşüm': 'bg-emerald-50 text-emerald-700 border-emerald-200',
};

function Amac({ tip, not }) {
  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded-md border text-[11px] font-medium whitespace-nowrap ${AMAC_STIL[tip] || 'bg-gray-50 text-gray-700 border-gray-200'}`}>
      {tip}{not ? ` (${not})` : ''}
    </span>
  );
}

export default function KixxEylul2026MedyaPlani() {
  return (
    <div className="p-6 max-w-7xl mx-auto space-y-16">

      <div className="bg-white rounded-2xl shadow-sm border overflow-hidden">
        <div className="bg-white border-b p-5 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
          <div className="flex items-center gap-4">
            <div className="rounded-lg bg-gray-900 px-3 py-2">
              <img src="/kixx/img/kixx-logo-white.png" alt="KIXX" className="h-7 w-auto object-contain" />
            </div>
            <div className="ml-1">
              <h2 className="text-lg font-bold text-gray-800">KIXX Eylül 2026 Medya Planı</h2>
              <p className="text-sm text-gray-500">Metropol İstanbul AVM, Ataşehir · üyelik / lead · Google (Arama + YouTube) · Meta (Lead + Etkileşim) · TikTok</p>
            </div>
          </div>
          <div className="flex items-center gap-3">
            <span className="inline-flex items-center px-3 py-1 bg-gray-100 text-gray-600 text-xs font-medium rounded-full border border-gray-200">
              1 - 30 Eylül 2026
            </span>
            <span className="inline-flex items-center px-3 py-1.5 bg-gray-800 text-white text-sm font-semibold rounded-full">
              Toplam: ₺130.000
            </span>
          </div>
        </div>

        <div className="p-6">

          {/* Eylül odağı */}
          <div className="mb-6 p-4 rounded-xl bg-cyan-50 border border-cyan-200">
            <p className="text-xs font-semibold text-cyan-800 mb-1">Eylül odağı: talebin oluştuğu yere yaklaşmak</p>
            <p className="text-[11px] text-cyan-700 leading-relaxed">
              Eylül, spor salonu kategorisinde yılın en yoğun üyelik ayıdır. İstanbul'da KIXX'in sattığı hizmetlerin
              toplam arama hacmi Ağustos'tan Eylül'e iki yıl üst üste yaklaşık %20 arttı. Bu artış aramada oluşuyor,
              sosyal medyada değil. Plan da buna göre kuruldu: Ağustos'ta bütçenin %68'i Meta'daydı, Eylül'de %57'si
              Google'da olacak. Ay toplamı ₺130.000.
              Meta tarafında yapı sadeleşiyor. Yalnızca ölçülen lead maliyeti en düşük üç kampanya açık kalıyor,
              statik kreatifli geniş kampanya bu ay hiç açılmıyor. Google tarafında ise Ağustos'ta tek kampanyada
              toplanmış olan jenerik, lokasyon ve marka sorguları üç ayrı kampanyaya bölünüyor ki bütçe ve teklif
              bağımsız yönetilebilsin.
              Havuz ve sauna Eylül'ün mesajı değil: "yüzme havuzu" araması Eylül'de iki yıl üst üste %33 düşüyor.
              Kreatifte üyelik, 12 ay taksit, pilates ve grup dersleri öne çıkar.
            </p>
          </div>

          {/* Arama talebi: Ağustos → Eylül. Kaynak Keyword Planner, geo İstanbul (21069),
              dil TR, GOOGLE_SEARCH, çekim 31 Ağu 2026. Planner değerleri bucket'tır
              (…6.600, 8.100, 9.900…), o yüzden pek çok kelimede değişim tam +%22 çıkar. */}
          <div className="mb-6 rounded-xl border border-slate-200 overflow-hidden">
            <div className="bg-slate-100 px-4 py-2.5 text-xs font-semibold text-gray-800">
              Neden Eylül: İstanbul'da kategori araması Ağustos'tan Eylül'e iki yıl üst üste artıyor
            </div>

            <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 p-4">
              <div className="rounded-lg border border-emerald-100 bg-emerald-50 p-3">
                <p className="text-[10px] font-medium text-emerald-700">Eylül 2025, Ağustos'a göre</p>
                <p className="text-lg font-bold text-emerald-800 mt-0.5">+%19,9</p>
                <p className="text-[10px] text-emerald-600">126.020 → 151.100 arama/ay</p>
              </div>
              <div className="rounded-lg border border-emerald-100 bg-emerald-50 p-3">
                <p className="text-[10px] font-medium text-emerald-700">Eylül 2024, Ağustos'a göre</p>
                <p className="text-lg font-bold text-emerald-800 mt-0.5">+%18,1</p>
                <p className="text-[10px] text-emerald-600">103.750 → 122.520 arama/ay</p>
              </div>
              <div className="rounded-lg border border-slate-200 bg-slate-50 p-3">
                <p className="text-[10px] font-medium text-gray-600">Eylül'de açılan ek talep</p>
                <p className="text-lg font-bold text-gray-800 mt-0.5">+25.080</p>
                <p className="text-[10px] text-gray-500">aylık ek arama (2025)</p>
              </div>
              <div className="rounded-lg border border-slate-200 bg-slate-50 p-3">
                <p className="text-[10px] font-medium text-gray-600">2025'in en yüksek üç ayı</p>
                <p className="text-lg font-bold text-gray-800 mt-0.5">Oca · Eki · Eyl</p>
                <p className="text-[10px] text-gray-500">164.280 · 153.880 · 151.100</p>
              </div>
            </div>

            <div className="overflow-x-auto">
              <table className="min-w-full text-[11px]">
                <thead className="bg-gray-50 text-gray-500">
                  <tr>
                    <th className="px-4 py-2 text-left font-medium uppercase tracking-wider">Kelime</th>
                    <th className="px-4 py-2 text-right font-medium uppercase tracking-wider">Ağu 2025</th>
                    <th className="px-4 py-2 text-right font-medium uppercase tracking-wider">Eyl 2025</th>
                    <th className="px-4 py-2 text-right font-medium uppercase tracking-wider">Değişim</th>
                    <th className="px-4 py-2 text-right font-medium uppercase tracking-wider">Ağu 2024</th>
                    <th className="px-4 py-2 text-right font-medium uppercase tracking-wider">Eyl 2024</th>
                    <th className="px-4 py-2 text-right font-medium uppercase tracking-wider">Değişim</th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-100 text-gray-700">
                  <tr>
                    <td className="px-4 py-2 font-medium">spor salonu</td>
                    <td className="px-4 py-2 text-right">60.500</td>
                    <td className="px-4 py-2 text-right">74.000</td>
                    <td className="px-4 py-2 text-right font-semibold text-emerald-600">+%22</td>
                    <td className="px-4 py-2 text-right">49.500</td>
                    <td className="px-4 py-2 text-right">60.500</td>
                    <td className="px-4 py-2 text-right text-emerald-600">+%22</td>
                  </tr>
                  <tr>
                    <td className="px-4 py-2 font-medium">pilates</td>
                    <td className="px-4 py-2 text-right">33.100</td>
                    <td className="px-4 py-2 text-right">40.500</td>
                    <td className="px-4 py-2 text-right text-emerald-600">+%22</td>
                    <td className="px-4 py-2 text-right">22.200</td>
                    <td className="px-4 py-2 text-right">27.100</td>
                    <td className="px-4 py-2 text-right text-emerald-600">+%22</td>
                  </tr>
                  <tr>
                    <td className="px-4 py-2 font-medium">reformer pilates</td>
                    <td className="px-4 py-2 text-right">8.100</td>
                    <td className="px-4 py-2 text-right">9.900</td>
                    <td className="px-4 py-2 text-right text-emerald-600">+%22</td>
                    <td className="px-4 py-2 text-right">8.100</td>
                    <td className="px-4 py-2 text-right">9.900</td>
                    <td className="px-4 py-2 text-right text-emerald-600">+%22</td>
                  </tr>
                  <tr>
                    <td className="px-4 py-2 font-medium">spinning</td>
                    <td className="px-4 py-2 text-right">4.400</td>
                    <td className="px-4 py-2 text-right">5.400</td>
                    <td className="px-4 py-2 text-right text-emerald-600">+%23</td>
                    <td className="px-4 py-2 text-right">4.400</td>
                    <td className="px-4 py-2 text-right">5.400</td>
                    <td className="px-4 py-2 text-right text-emerald-600">+%23</td>
                  </tr>
                  <tr>
                    <td className="px-4 py-2 font-medium">yoga</td>
                    <td className="px-4 py-2 text-right">5.400</td>
                    <td className="px-4 py-2 text-right">6.600</td>
                    <td className="px-4 py-2 text-right text-emerald-600">+%22</td>
                    <td className="px-4 py-2 text-right">6.600</td>
                    <td className="px-4 py-2 text-right">6.600</td>
                    <td className="px-4 py-2 text-right text-gray-400">%0</td>
                  </tr>
                  <tr className="bg-amber-50/60">
                    <td className="px-4 py-2 font-semibold">ataşehir spor salonu</td>
                    <td className="px-4 py-2 text-right">1.600</td>
                    <td className="px-4 py-2 text-right">1.900</td>
                    <td className="px-4 py-2 text-right font-semibold text-emerald-600">+%19</td>
                    <td className="px-4 py-2 text-right">1.900</td>
                    <td className="px-4 py-2 text-right">2.400</td>
                    <td className="px-4 py-2 text-right font-semibold text-emerald-600">+%26</td>
                  </tr>
                  <tr>
                    <td className="px-4 py-2 font-medium">fitness salonu</td>
                    <td className="px-4 py-2 text-right">5.400</td>
                    <td className="px-4 py-2 text-right">5.400</td>
                    <td className="px-4 py-2 text-right text-gray-400">%0</td>
                    <td className="px-4 py-2 text-right">3.600</td>
                    <td className="px-4 py-2 text-right">3.600</td>
                    <td className="px-4 py-2 text-right text-gray-400">%0</td>
                  </tr>
                  <tr>
                    <td className="px-4 py-2 font-medium text-gray-500">yüzme havuzu</td>
                    <td className="px-4 py-2 text-right">9.900</td>
                    <td className="px-4 py-2 text-right">6.600</td>
                    <td className="px-4 py-2 text-right font-semibold text-rose-600">-%33</td>
                    <td className="px-4 py-2 text-right">9.900</td>
                    <td className="px-4 py-2 text-right">6.600</td>
                    <td className="px-4 py-2 text-right font-semibold text-rose-600">-%33</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div className="px-4 py-2.5 bg-slate-50 border-t border-slate-200 text-[11px] text-gray-700 leading-relaxed">
              Artışın tamamı üyelik, pilates ve grup dersleri tarafında. Kulübün bulunduğu ilçenin adını taşıyan
              "ataşehir spor salonu" sorgusu iki yıl da Eylül'de büyüyor; satın alma niyeti en yüksek ve rekabeti en
              pahalı sorgu bu, Google'ın verdiği sayfa üstü teklif aralığının üst ucu ₺204,60.
              Tersi yönde tek veri "yüzme havuzu": Eylül'de iki yıl üst üste %33 düşüyor, bu yüzden havuz Eylül
              kreatifinin ana mesajı değil.
              Sepet 12 hizmet kelimesinden oluşuyor: spor salonu, spor salonu fiyatları, fitness salonu,
              ataşehir spor salonu, pilates, reformer pilates, personal trainer, spor salonu üyelik, yoga, spinning,
              kickbox, yakınımdaki spor salonu. Kaynak Google Ads Keyword Planner, İstanbul, Türkçe,
              yalnızca Google Arama (Arama Ortakları hariç).
            </div>
          </div>

          {/* Ön koşul, en üstte */}
          <div className="mb-6 rounded-xl border-2 border-rose-300 bg-rose-50 p-4">
            <p className="text-xs font-semibold text-rose-900 mb-1">Bu planın tek ön koşulu: Google'da dönüşüm ölçümü</p>
            <p className="text-[11px] text-rose-800 leading-relaxed">
              Ağustos'ta Google Arama'ya ₺15.877 gitti, 563 tıklama geldi, hesapta <strong>3 dönüşüm</strong> kayıtlı.
              Bu, kampanyanın değil dönüşüm kurulumunun sorunu. Eylül'de Google'ın payı ₺74.000'e, yani bütçenin
              %57'sine çıkıyor. Ölçüm kurulmadan bu paranın harcanması, ayın sonunda "Google iyi çalıştı mı" sorusunu
              cevapsız bırakır.
              kixx.com.tr üzerinde form gönderimi ve telefon tıklaması <strong>5 Eylül'e kadar</strong> dönüşüm olarak
              tanımlanmalı. Yetişmezse arama kampanyaları ₺25.000 ile başlar, dönüşüm kaydı görülene kadar
              yükseltilmez; bekleyen ₺33.000 ay içinde Meta lead kampanyalarına aktarılır. Ay yine ₺130.000 kapanır,
              ama ölçülemeyen para harcanmaz.
            </p>
          </div>

          {/* Ağustos gerçekleşen → Eylül plan */}
          <div className="mb-6 rounded-xl border border-slate-200 overflow-hidden">
            <div className="bg-slate-100 px-4 py-2.5 text-xs font-semibold text-gray-800">Ağustos 2026 gerçekleşen ve Eylül 2026 planı</div>
            <div className="overflow-x-auto">
              <table className="min-w-full text-[11px]">
                <thead className="bg-gray-50 text-gray-500">
                  <tr>
                    <th className="px-4 py-2 text-left font-medium uppercase tracking-wider">Mecra</th>
                    <th className="px-4 py-2 text-right font-medium uppercase tracking-wider">Ağustos harcama</th>
                    <th className="px-4 py-2 text-right font-medium uppercase tracking-wider">Ağustos birim maliyet</th>
                    <th className="px-4 py-2 text-left font-medium uppercase tracking-wider">Ağustos sonucu</th>
                    <th className="px-4 py-2 text-right font-medium uppercase tracking-wider">Eylül planı</th>
                    <th className="px-4 py-2 text-right font-medium uppercase tracking-wider">Değişim</th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-100 text-gray-700">
                  <tr>
                    <td className="px-4 py-2 font-medium">Google Arama</td>
                    <td className="px-4 py-2 text-right">₺15.877</td>
                    <td className="px-4 py-2 text-right">₺28,20 CPC</td>
                    <td className="px-4 py-2">16.337 gösterim · 563 tık · CTR %3,45 · <span className="text-rose-600">yalnızca 3 ölçülü dönüşüm</span></td>
                    <td className="px-4 py-2 text-right font-semibold">₺58.000</td>
                    <td className="px-4 py-2 text-right text-emerald-600">+%265</td>
                  </tr>
                  <tr>
                    <td className="px-4 py-2 font-medium">YouTube</td>
                    <td className="px-4 py-2 text-right">₺3.292</td>
                    <td className="px-4 py-2 text-right">₺20,36 CPM</td>
                    <td className="px-4 py-2">161.691 gösterim · 3.671 izlenme</td>
                    <td className="px-4 py-2 text-right font-semibold">₺16.000</td>
                    <td className="px-4 py-2 text-right text-emerald-600">+%386</td>
                  </tr>
                  <tr>
                    <td className="px-4 py-2 font-medium">Meta Ads</td>
                    <td className="px-4 py-2 text-right">₺40.398</td>
                    <td className="px-4 py-2 text-right">₺3,93 CPC · ₺108 CPM</td>
                    <td className="px-4 py-2">159 lead · lead başı ₺254 (hesap geneli)</td>
                    <td className="px-4 py-2 text-right font-semibold">₺50.000</td>
                    <td className="px-4 py-2 text-right text-emerald-600">+%24</td>
                  </tr>
                  <tr>
                    <td className="px-4 py-2 font-medium">TikTok Ads</td>
                    <td className="px-4 py-2 text-right text-gray-400">₺0</td>
                    <td className="px-4 py-2 text-right text-gray-400">-</td>
                    <td className="px-4 py-2 text-gray-500">reklam hesabı hâlâ açılmadı</td>
                    <td className="px-4 py-2 text-right font-semibold">₺6.000</td>
                    <td className="px-4 py-2 text-right text-blue-600">yeni</td>
                  </tr>
                  <tr className="bg-gray-50 font-semibold text-gray-800">
                    <td className="px-4 py-2">Toplam</td>
                    <td className="px-4 py-2 text-right">₺59.567</td>
                    <td className="px-4 py-2 text-right">-</td>
                    <td className="px-4 py-2">159 ölçülü lead</td>
                    <td className="px-4 py-2 text-right">₺130.000</td>
                    <td className="px-4 py-2 text-right text-emerald-600">+%118</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="px-4 py-2.5 bg-slate-50 border-t border-slate-200 text-[11px] text-gray-700">
              Ağustos'ta bütçenin %68'i Meta'daydı, Google %32'ydi. Eylül'de oran tersine dönüyor: Google %57, Meta %38.
              Bunun karşılığı ölçülü lead sayısında görünecek bir düşüştür. Meta'dan beklenen lead 375'ten
              <strong> 235'e</strong> iner. Google'ın bunu kapatıp kapatmadığını ancak dönüşüm ölçümü kurulursa göreceğiz.
            </div>
          </div>

          {/* Amaç bazlı dağılım */}
          <div className="rounded-xl border overflow-hidden mb-6">
            <div className="bg-slate-100 px-4 py-3 font-semibold text-gray-800">Kampanya amacına göre bütçe dağılımı</div>
            <div className="px-4 pt-4">
              <div className="flex w-full h-3 rounded-full overflow-hidden border border-gray-200">
                <div className="bg-emerald-400" style={{ width: '78.5%' }} title="Dönüşüm %78" />
                <div className="bg-red-400" style={{ width: '16.9%' }} title="Farkındalık %17" />
                <div className="bg-pink-400" style={{ width: '4.6%' }} title="Etkileşim %5" />
              </div>
            </div>
            <div className="overflow-x-auto">
              <table className="min-w-full text-[12px] mt-3">
                <thead className="bg-gray-50 text-gray-500">
                  <tr>
                    <th className="px-4 py-2 text-left font-medium uppercase tracking-wider text-[11px]">Amaç</th>
                    <th className="px-4 py-2 text-right font-medium uppercase tracking-wider text-[11px]">Bütçe</th>
                    <th className="px-4 py-2 text-right font-medium uppercase tracking-wider text-[11px]">Pay</th>
                    <th className="px-4 py-2 text-left font-medium uppercase tracking-wider text-[11px]">Kampanyalar</th>
                    <th className="px-4 py-2 text-left font-medium uppercase tracking-wider text-[11px]">Hedeflenen çıktı</th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-100 text-gray-700">
                  <tr>
                    <td className="px-4 py-2.5"><Amac tip="Dönüşüm" not="lead" /></td>
                    <td className="px-4 py-2.5 text-right font-semibold">₺102.000</td>
                    <td className="px-4 py-2.5 text-right">%78</td>
                    <td className="px-4 py-2.5">Google Arama 3 kampanya (₺58.000) · Meta 3 lead kampanyası (₺44.000)</td>
                    <td className="px-4 py-2.5">3.292 arama tıklaması · 235 ölçülü Meta lead</td>
                  </tr>
                  <tr>
                    <td className="px-4 py-2.5"><Amac tip="Farkındalık" /></td>
                    <td className="px-4 py-2.5 text-right font-semibold">₺22.000</td>
                    <td className="px-4 py-2.5 text-right">%17</td>
                    <td className="px-4 py-2.5">YouTube erişim (₺16.000) · TikTok video izlenme (₺6.000)</td>
                    <td className="px-4 py-2.5">936.000 gösterim · 118.000 izlenme</td>
                  </tr>
                  <tr>
                    <td className="px-4 py-2.5"><Amac tip="Etkileşim" /></td>
                    <td className="px-4 py-2.5 text-right font-semibold">₺6.000</td>
                    <td className="px-4 py-2.5 text-right">%5</td>
                    <td className="px-4 py-2.5">Meta etkileşim</td>
                    <td className="px-4 py-2.5">1.030 gerçek etkileşim · 36.000 video izlenme</td>
                  </tr>
                  <tr className="bg-gray-50 font-semibold text-gray-800">
                    <td className="px-4 py-2.5">Toplam</td>
                    <td className="px-4 py-2.5 text-right">₺130.000</td>
                    <td className="px-4 py-2.5 text-right">%100</td>
                    <td className="px-4 py-2.5">4 mecra · 8 kampanya</td>
                    <td className="px-4 py-2.5">235 lead · 12.882 tıklama · 1,26M gösterim</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="px-4 py-2.5 bg-amber-50 border-t border-amber-100 text-[11px] text-amber-800">
              Etkileşim kampanyasının payı %11'den %5'e iniyor. Bu, Ekim'in yeniden hedefleme havuzunu besleyen tek
              kalemdir; ₺6.000 havuzu canlı tutmaya yeter, büyütmeye yetmez. Eylül'de biriken izleyici Ekim'de
              Ağustos'takinden dar bir kitle olacak. Bilinçli bir tercih, ama Ekim planı yazılırken hatırlanmalı.
            </div>
          </div>

          {/* Özet kartlar */}
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-6">
            <div className="rounded-xl border border-blue-100 bg-blue-50 p-4">
              <div className="flex items-center gap-2 mb-1">
                <img src="/google_ads-512.webp" alt="Google" className="w-5 h-5 object-contain" />
                <span className="text-xs font-medium text-blue-700">Google Ads</span>
              </div>
              <p className="text-xl font-bold text-blue-800">₺74.000</p>
              <p className="text-[10px] text-blue-600 mt-0.5">%57 · Arama ₺58.000 + YouTube ₺16.000</p>
            </div>
            <div className="rounded-xl border border-indigo-100 bg-indigo-50 p-4">
              <div className="flex items-center gap-2 mb-1">
                <img src="/6033716.png" alt="Meta" className="w-5 h-5 object-contain" />
                <span className="text-xs font-medium text-indigo-700">Meta Ads</span>
              </div>
              <p className="text-xl font-bold text-indigo-800">₺50.000</p>
              <p className="text-[10px] text-indigo-600 mt-0.5">%38 · 3 lead + 1 etkileşim</p>
            </div>
            <div className="rounded-xl border border-gray-200 bg-gray-50 p-4">
              <div className="flex items-center gap-2 mb-1">
                <img src="/tiktokv4.svg" alt="TikTok" className="w-5 h-5 object-contain" />
                <span className="text-xs font-medium text-gray-700">TikTok Ads</span>
              </div>
              <p className="text-xl font-bold text-gray-800">₺6.000</p>
              <p className="text-[10px] text-gray-600 mt-0.5">%5 · ilk açılış, test</p>
            </div>
          </div>

          {/* ANA PLAN TABLOSU */}
          <div className="rounded-xl border overflow-hidden mb-8">
            <div className="bg-slate-100 px-4 py-3 font-semibold text-gray-800">Medya Planı, KIXX Eylül 2026</div>
            <div className="overflow-x-auto">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Mecra</th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Kampanya</th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Hedef kitle</th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Amaç</th>
                    <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">Bütçe</th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-100 text-[12px] text-gray-700">

                  {/* Google */}
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3 font-medium align-top" rowSpan={4}>
                      <div className="flex items-center gap-2">
                        <img src="/google_ads-512.webp" alt="Google Ads" className="w-5 h-5 object-contain" />
                        <span>Google Ads</span>
                      </div>
                    </td>
                    <td className="px-4 py-3">Arama, <strong>kategori kelimeleri</strong></td>
                    <td className="px-4 py-3">spor salonu, fitness salonu, spor salonu üyelik, pilates, reformer pilates</td>
                    <td className="px-4 py-3"><Amac tip="Dönüşüm" not="lead" /></td>
                    <td className="px-4 py-3 text-right font-medium">₺28.000</td>
                  </tr>
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3">Arama, <strong>lokasyon kelimeleri</strong> <span className="text-[10px] text-blue-600 font-medium">yeni</span></td>
                    <td className="px-4 py-3">ataşehir spor salonu, ataşehir fitness, yakınımdaki spor salonu</td>
                    <td className="px-4 py-3"><Amac tip="Dönüşüm" not="lead" /></td>
                    <td className="px-4 py-3 text-right font-medium">₺20.000</td>
                  </tr>
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3">Arama, <strong>marka kelimeleri</strong> <span className="text-[10px] text-blue-600 font-medium">yeni</span></td>
                    <td className="px-4 py-3">kixx sports club, kixx ataşehir, kixx spor salonu</td>
                    <td className="px-4 py-3"><Amac tip="Dönüşüm" not="lead" /></td>
                    <td className="px-4 py-3 text-right font-medium">₺10.000</td>
                  </tr>
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3">YouTube, erişim</td>
                    <td className="px-4 py-3">Kulüp çevresi, spor ve wellness ilgi alanları</td>
                    <td className="px-4 py-3"><Amac tip="Farkındalık" /></td>
                    <td className="px-4 py-3 text-right font-medium">₺16.000</td>
                  </tr>
                  <tr className="bg-blue-50 font-semibold text-blue-800">
                    <td className="px-4 py-3" colSpan={4}>Google Ads toplam</td>
                    <td className="px-4 py-3 text-right">₺74.000</td>
                  </tr>

                  {/* Meta */}
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3 font-medium align-top" rowSpan={4}>
                      <div className="flex items-center gap-2">
                        <img src="/6033716.png" alt="Meta" className="w-5 h-5 object-contain" />
                        <span>Meta Ads</span>
                      </div>
                    </td>
                    <td className="px-4 py-3">Potansiyel müşteri, <strong>video kreatif</strong></td>
                    <td className="px-4 py-3">Ataşehir çevresi, 22-50 yaş, spor ve pilates ilgisi</td>
                    <td className="px-4 py-3"><Amac tip="Dönüşüm" not="lead" /></td>
                    <td className="px-4 py-3 text-right font-medium">₺22.000</td>
                  </tr>
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3">Potansiyel müşteri, <strong>CRM kitlesi</strong></td>
                    <td className="px-4 py-3">CRM listesi ve benzer kitle</td>
                    <td className="px-4 py-3"><Amac tip="Dönüşüm" not="lead" /></td>
                    <td className="px-4 py-3 text-right font-medium">₺14.000</td>
                  </tr>
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3">Potansiyel müşteri, <strong>yeniden hedefleme</strong> <span className="text-[10px] text-blue-600 font-medium">yeni</span></td>
                    <td className="px-4 py-3">Video izleyicileri, sayfa etkileşimcileri, site ziyaretçileri</td>
                    <td className="px-4 py-3"><Amac tip="Dönüşüm" not="lead" /></td>
                    <td className="px-4 py-3 text-right font-medium">₺8.000</td>
                  </tr>
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3">Etkileşim</td>
                    <td className="px-4 py-3">Ataşehir ve çevresi, geniş kitle</td>
                    <td className="px-4 py-3"><Amac tip="Etkileşim" /></td>
                    <td className="px-4 py-3 text-right font-medium">₺6.000</td>
                  </tr>
                  <tr className="bg-indigo-50 font-semibold text-indigo-800">
                    <td className="px-4 py-3" colSpan={4}>Meta Ads toplam</td>
                    <td className="px-4 py-3 text-right">₺50.000</td>
                  </tr>

                  {/* TikTok */}
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3 font-medium align-top">
                      <div className="flex items-center gap-2">
                        <img src="/tiktokv4.svg" alt="TikTok" className="w-5 h-5 object-contain" />
                        <span>TikTok Ads</span>
                      </div>
                    </td>
                    <td className="px-4 py-3">Video izlenme <span className="text-[10px] text-blue-600 font-medium">yeni</span></td>
                    <td className="px-4 py-3">20-45 yaş, kulüp çevresi</td>
                    <td className="px-4 py-3"><Amac tip="Farkındalık" /></td>
                    <td className="px-4 py-3 text-right font-medium">₺6.000</td>
                  </tr>
                  <tr className="bg-gray-100 font-semibold text-gray-800">
                    <td className="px-4 py-3" colSpan={4}>TikTok Ads toplam</td>
                    <td className="px-4 py-3 text-right">₺6.000</td>
                  </tr>

                  <tr className="bg-gray-800 text-white font-bold">
                    <td className="px-4 py-3" colSpan={4}>GENEL TOPLAM</td>
                    <td className="px-4 py-3 text-right">₺130.000</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="px-4 py-2.5 bg-slate-50 border-t border-slate-200 text-[11px] text-gray-700">
              Ölçülü lead hedefi yalnızca Meta üzerinden verilir. Google Arama'dan da lead gelecek, ancak dönüşüm
              ölçümü kurulmadan tıklamadan lead'e geçiş oranı bilinmiyor; sayı vermek yanıltıcı olur.
            </div>
          </div>

          {/* Plan ↔ gerçekleşen; mecralardan canlı okunur (bkz. EylulGerceklesen). */}
          <EylulGerceklesen
            brandId={BRAND_ID}
            plan={MECRA_PLANI}
            kpi="lead"
            notlar="Google tarafındaki form sayısı bu hesapta ölçülmüyor; sonuç sütunu yalnızca Meta'nın raporladığı formları sayar."
          />

          {/* Strateji */}
          <div className="rounded-xl border overflow-hidden mb-8">
            <div className="bg-slate-100 px-4 py-3 font-semibold text-gray-800">Uygulama notları</div>
            <div className="p-5 grid grid-cols-1 md:grid-cols-2 gap-5 text-[12px] text-gray-700">
              <div>
                <p className="font-semibold text-gray-800 mb-1">Aramada üç kampanya, tek kampanya değil</p>
                <p className="leading-relaxed">
                  Ağustos'ta jenerik, lokasyon ve marka sorguları tek kampanyada toplanmıştı. Ortalama CPC ₺28,20 çıktı.
                  Bu ortalamanın içinde ₺6'lık marka tıklaması da, ₺40'lık kategori tıklaması da var; ikisi aynı bütçe
                  havuzundan yarışınca marka trafiği ucuz olduğu için sistemin kolayına gidiyor.
                  Bütçe ₺58.000'e çıkarken bu ayrımın yapılmaması, paranın büyük kısmının zaten bizi arayan kişiye
                  gitmesi demek olurdu. Marka kampanyası ₺10.000 ile sınırlanıyor, jenerik ve Ataşehir kendi tekliflerini
                  kendi bütçelerinde veriyor. Ataşehir kampanyası sayfa üstünde kalmak için daha yüksek teklikle çalışacak:
                  Google'ın verdiği sayfa üstü teklif aralığının üst ucu bu sorguda ₺204,60.
                </p>
              </div>
              <div>
                <p className="font-semibold text-gray-800 mb-1">Aramada asıl darboğaz bütçe değil, sıralama olabilir</p>
                <p className="leading-relaxed">
                  Ağustos'ta arama kampanyası 16.337 gösterim aldı. Kategorinin İstanbul'daki aylık hacmi bunun kat kat
                  üstünde. Bütçe üç katına çıkınca gösterimin de üç katına çıkacağı garanti değil: kayıp gösterim payının
                  ne kadarının bütçeden, ne kadarının reklam sıralamasından geldiği ölçülmeli.
                  İlk hafta içinde arama terimleri raporu ve gösterim payı kırılımı çıkarılacak. Kayıp ağırlıklı olarak
                  sıralamadan geliyorsa çözüm bütçe değil, açılış sayfası ve reklam metni tarafında.
                </p>
              </div>
              <div>
                <p className="font-semibold text-gray-800 mb-1">Meta'da yapı sadeleşiyor</p>
                <p className="leading-relaxed">
                  Bütçe ₺50.000'e inince kampanya sayısı beşten dörde düşüyor. Açık kalanlar Ağustos'ta ölçülen en düşük
                  lead maliyetine sahip olanlar: video kreatifli kampanya ₺146, CRM kitlesine giden kampanya ₺156.
                  Statik kreatifli geniş kampanya Ağustos'ta ₺223, Temmuz'da ₺276 lead maliyeti verdi; aynı paranın
                  ₺146'ya lead getirdiği bir ayda onu açık tutmanın karşılığı yok, bu ay hiç açılmıyor.
                  Yeni yeniden hedefleme kampanyası, Haziran'dan Ağustos'a etkileşim
                  kampanyalarının biriktirdiği 551.780 video izlenmesi ve 9.998 gerçek etkileşimden oluşan havuza gidiyor.
                  Bu havuz bugüne kadar lead kampanyalarında hiç kullanılmadı. Kitle dar olduğu için CPM yüksek olacak,
                  ama markayı zaten tanıdığından lead maliyetinin soğuk kitlenin altında kalması bekleniyor.
                </p>
              </div>
              <div>
                <p className="font-semibold text-gray-800 mb-1">TikTok, ölçüm için açılıyor</p>
                <p className="leading-relaxed">
                  Ağustos planında ₺2.000 ayrılmıştı ama reklam hesabı açılmadığı için hiç harcanmadı. Eylül'de ₺6.000
                  ile yeniden konuluyor. Bu bütçe kanalın çalışıp çalışmadığını gösterecek kadar, ana bütçeyi lead'den
                  çalmayacak kadar küçük. Ay sonunda kendi ölçülen birim maliyeti yoksa Ekim'de kapatılır.
                  Hesap açılışı ve piksel kurulumu 5 Eylül'e kadar tamamlanmazsa bütçe Meta yeniden hedeflemeye aktarılır.
                </p>
              </div>
            </div>
          </div>

          {/* Projeksiyon notu */}
          <div className="p-4 rounded-xl bg-amber-50 border border-amber-200">
            <div className="flex items-start gap-2.5">
              <div className="flex-shrink-0 mt-0.5">
                <svg className="w-4 h-4 text-amber-500" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                </svg>
              </div>
              <div>
                <p className="text-xs font-semibold text-amber-800">Projeksiyon notu</p>
                <p className="text-[11px] text-amber-700 mt-1 leading-relaxed">
                  Meta satırları hesabın Ağustos 2026 gerçekleşen kampanya verisinden türetildi. Eylül rekabeti için
                  birim maliyetlere %15 CPM ve %25 lead maliyeti primi eklendi. Yeniden hedefleme kampanyasının geçmiş
                  verisi olmadığı için lead maliyeti soğuk kitleyle Dar Video arasında, ₺185 varsayıldı.
                  Google Arama satırlarında CPC tabanı Ağustos'ta ölçülen ₺28,20; Ataşehir kampanyasında ₺32,
                  marka kampanyasında ₺6 varsayıldı. Bu iki kampanya hiç ayrı çalışmadı, dolayısıyla ayrışmış CPC verisi yok.
                  Aramadan gelecek lead sayısı bilerek projekte edilmedi: dönüşüm kurulumu tamamlanmadan tıklamadan
                  lead'e geçiş oranı bilinmiyor, sayı vermek yanıltıcı olur.
                  YouTube gösterimi Ağustos'ta ölçülen ₺20,36 CPM üzerine %13 eklenerek hesaplandı; bu bir erişim
                  satın alımıdır, izlenme sayısı ikincil çıktıdır.
                  TikTok satırının tamamı varsayımdır, markanın TikTok reklam hesabı yok.
                  Erişim rakamları platform içi tekildir, mecralar arası çakışma ölçülemez.
                  Ağustos verisi ay kapandıktan sonra, 1 Eylül 2026'da çekildi.
                </p>
              </div>
            </div>
          </div>

        </div>
      </div>

    </div>
  );
}
